// extracted by mini-css-extract-plugin
module.exports = {"root":"PlasmicHamdastViraWidget_root__l9eH7","text":"PlasmicHamdastViraWidget_text__KeMJm"};